import * as amplitude from '@amplitude/analytics-browser';
import config from "../config";

export function initAnalytics() {
  amplitude.init(config.amplitudeAPIKey, {
    autocapture: {
      elementInteractions: true,
    }
  });
}
